import React, { useState } from "react";
import { toast } from "./ui/sonner";
import { FileDown, FileSpreadsheet, Send, Loader2, CheckCircle2 } from "lucide-react";
import { fmtD } from "../lib/date";

/* 催办统计：导出 Excel / PDF + 一键发给 HR（绩效附件） */
export function NudgeStatsExport({ api, zh, month, branch, canSend, lastSend, onSent }) {
  const [busy, setBusy] = useState("");
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const dl = async (ext) => {
    setBusy(ext);
    try {
      const res = await api.get(`/hrms/branch-digest/nudge-stats/export.${ext}`, { params: { month, branch }, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = `PM_nudge_stats_${month}${branch ? `_${branch}` : ""}.${ext}`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch { toast.error(zh ? "导出失败" : "Export failed"); } finally { setBusy(""); }
  };
  const send = async () => {
    setBusy("send");
    try {
      const { data } = await api.post("/hrms/branch-digest/nudge-stats/send-hr", { month, branch, note: note.trim() });
      const s = data.send;
      toast.success(zh ? `已发给 HR ${s.bells} 人（邮件附件 ${s.emailed} 封${s.mailConfigured ? "" : "，邮件通道未配置仅铃铛"}）` : `Sent to ${s.bells} HR (${s.emailed} emails)`);
      setOpen(false); setNote("");
      onSent?.(s);
    } catch (e) { toast.error(e?.detailText || (zh ? "发送失败" : "Send failed")); } finally { setBusy(""); }
  };
  const btn = "inline-flex items-center gap-1.5 text-xs font-medium text-slate-700 border border-slate-200 rounded-full px-3 py-1.5 hover:bg-slate-50 disabled:opacity-50";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="ns-export">
      <button onClick={() => dl("xlsx")} disabled={!!busy} data-testid="ns-export-xlsx" className={btn}>{busy === "xlsx" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileSpreadsheet className="h-3.5 w-3.5" />}Excel</button>
      <button onClick={() => dl("pdf")} disabled={!!busy} data-testid="ns-export-pdf" className={btn}>{busy === "pdf" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileDown className="h-3.5 w-3.5" />}PDF</button>
      {canSend && (
        <div className="relative">
          <button onClick={() => setOpen((v) => !v)} disabled={!!busy} data-testid="ns-send-hr" className="inline-flex items-center gap-1.5 text-xs font-semibold text-white bg-brand-500 hover:bg-brand-600 rounded-full px-3 py-1.5 disabled:opacity-50"><Send className="h-3.5 w-3.5" />{zh ? "发给 HR（绩效附件）" : "Send to HR"}</button>
          {open && (
            <div className="absolute right-0 top-9 z-30 w-80 bg-white rounded-xl border border-slate-200 shadow-xl p-3 space-y-2" data-testid="ns-send-panel">
              <p className="text-xs text-slate-600">{zh ? `将 ${month} 的 PM 催办统计（PDF + Excel）发给全部 HR 账号：有邮箱走邮件附件并铃铛提醒，无邮箱仅铃铛；抄送本人。` : `Email PDF + Excel of ${month} to all HR accounts (bell notice too), cc yourself.`}</p>
              <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} maxLength={500} data-testid="ns-send-note" placeholder={zh ? "给 HR 的备注（可选），如：请纳入本月 PM 绩效评估" : "Note for HR (optional)"} className="w-full text-xs rounded-lg border border-slate-200 px-2.5 py-1.5" />
              <div className="flex justify-end gap-2">
                <button onClick={() => setOpen(false)} data-testid="ns-send-cancel" className="text-xs text-slate-400 hover:text-slate-600 px-2 py-1">{zh ? "取消" : "Cancel"}</button>
                <button onClick={send} disabled={busy === "send"} data-testid="ns-send-confirm" className="inline-flex items-center gap-1 text-xs font-semibold text-white bg-brand-500 hover:bg-brand-600 rounded-full px-3 py-1 disabled:opacity-50">{busy === "send" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />}{zh ? "确认发送" : "Send"}</button>
              </div>
            </div>
          )}
        </div>
      )}
      {lastSend && <span className="text-[11px] text-emerald-700 inline-flex items-center gap-1" data-testid="ns-send-last"><CheckCircle2 className="h-3 w-3" />{zh ? `已于 ${fmtD(lastSend.at)} 由 ${lastSend.byName} 发给 HR ${lastSend.bells} 人（邮件 ${lastSend.emailed}）` : `Sent ${fmtD(lastSend.at)} by ${lastSend.byName} → ${lastSend.bells} HR (${lastSend.emailed} emails)`}</span>}
    </div>
  );
}
